<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['gift_product_code']">
              <a-input :placeholder="language['common.pleaseInput'] + language['gift_product_code']"
                v-model="queryParam.code"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['gift_product_name']">
              <a-input :placeholder="language['common.pleaseInput'] + language['gift_product_name']"
                v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="language['gift_user_app']" :labelCol="labelCol">
              <a-select v-model="queryParam.app"
                :placeholder="language['common.pleaseChoose'] + language['gift_user_app']" :options="appList"
                @change="handlerApp" :disabled='appLimit.flag'>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24" v-has="'produc:supplier'">
            <a-form-item :label="language['gift_product_vendor']">
              <a-select v-model="queryParam.supplier" @change="updateSupplier"
                :placeholder="language['common.pleaseChoose'] + language['gift_product_vendor']">
                <a-select-option v-for='(v, k) in vendorMap' :key='k' :value='k' :label='v'>
                  {{ v }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24" v-has="'produc:supplier'">
              <a-form-item :label="language['gift_merchant_name']">
                <a-select v-model="queryParam.businessName" @change="updateBusiness"
                  :placeholder="language['common.pleaseChoose'] + language['gift_merchant_name']">
                  <a-select-option v-for='(v, k) in businessMap' :key='k' :value='k' :label='v'>
                    {{ v }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-model-item :label="language['gift_up_down']" :labelCol="labelCol">
                <j-dict-select-tag v-model="queryParam.status" :type="'list'" dictCode="gift_up_down"
                  :disabled="formDisabled" />
              </a-form-model-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ language['common.searchButton'] }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                language['common.resetButton'] }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'product:add'">{{ language['common.insertButton']
      }}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('商品管理列表')" v-has="'product:export'">{{
        language['common.exportButton'] }}</a-button>

      <a-button type="primary" icon="download" v-has="'product:import'" @click="downloadTemplate()">{{
        language['common.import.template.download'] }}</a-button>

      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl"
        @change="handleImportExcel">
        <a-button type="primary" icon="import" v-has="'product:import'">{{ language['common.importButton'] }}</a-button>
      </a-upload>

      <a-button type="primary" icon="eye" @click="handlePreviewProductList">{{ language['common.preview'] }}</a-button>

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel" v-if="isHideDele">
            <a-icon type="delete" />{{ language['common.delete'] }}
          </a-menu-item>
          <a-menu-item key="2" @click="handleUpOrDown(1)">
            <a-icon type="up" />上架
          </a-menu-item>
          <a-menu-item key="2" @click="handleUpOrDown(0)">
            <a-icon type="down" />下架
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px" v-has="'product:delete'"> {{ language['common.batchAction'] }}
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ language['common.choosed'] }} <a
          style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{ language['common.item'] }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ language['common.clear'] }}</a>
      </div>

      <a-table ref="table" size="middle" :scroll="{ x: true }" bordered rowKey="id" :columns="columns"
        :dataSource="dataSource" :pagination="ipagination" :loading="false"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" class="j-table-force-nowrap"
        @change="handleTableChange">
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgViewCode(text, applicationCode)" @click="imgView(getImgViewCode(text, applicationCode))"
            height="25px" width="50px" alt=""
            style="max-width:80px;font-size: 12px;font-style: italic;cursor: pointer;" />
          <a-modal :mask="false" :width="1000" :title="language['gift_product_thumbnail']" :visible="previewVisible"
            :confirm-loading="false" :ok-button-props="{ props: { disabled: true } }" @cancel="handleCancel"
            :cancelText="language['common.closeButton']">
            <img alt="example" style="width: 100%;" :src="previewImage" />
          </a-modal>
        </template>
        <span slot="switchSlot" slot-scope="status, record, idx">
          <a-switch :checked='status' @click='changeStatus(status, record, idx)' />
        </span>

        <span slot="action" slot-scope="text, record">
          <a-button type="link" @click="handleEdit(record)" :disabled="record.activeStatus === 2"
            v-has="'product:edit'">{{ language['common.edit'] }}</a-button>

          <a-divider type="vertical" />
          <a @click="handleCopy(record)" v-has="'product:copy'">{{ language['epi.copy'] }}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ language['common.more'] }}
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ language['common.detailsButton'] }}</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handlePreviewProduct(record)">{{ language['common.preview'] }}</a>
              </a-menu-item>
              <a-menu-item v-has="'product:delete'" v-if="record.status === 0 && record.activeStatus === 0">
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record)">
                  <a>{{ language['common.delete'] }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <gift-product-info-modal ref="modalForm" @ok="modalFormOk" :vendorList="vendorList"
      :appList="appList"></gift-product-info-modal>

    <preview-product-modal  :visible="previewProduct" :record-data="previewRecord" :product-id='previewRecord.id' :tags-data='tags'
      @close="closePreviewProduct" />
    <preview-product-list-modal :visible="previewProductList" :record="dataSource" @close="closePreviewProductList" />
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import GiftProductInfoModal from './modules/GiftProductInfoModal'
import PreviewProductModal from './modules/PreviewProductModal'
import PreviewProductListModal from './modules/PreviewProductListModal'
import { getAction, postAction, deleteAction, downFile } from '@/api/manage'

export default {
  name: 'GiftProductInfoList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    GiftProductInfoModal,
    PreviewProductListModal,
    PreviewProductModal,
  },
  data() {
    const language = this.$store.getters.language
    return {
      disableMixinCreated: true,
      description: 'gift_product_info管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: language['gift_product_code'],
          align: 'center',
          dataIndex: 'code',
        },
        {
          title: language['gift_product_name'],
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: language['gift_product_thumbnail'],
          align: 'center',
          dataIndex: 'thumbnail',
          scopedSlots: { customRender: 'imgSlot' },
        },
        {
          title: language['gift_product_price'],
          align: 'center',
          dataIndex: 'price',
        },
        {
          title: language['gift_market_price'],
          align: 'center',
          dataIndex: 'marketPrice',
        },
        {
          title: language['gift_vendor_name'],
          align: 'center',
          dataIndex: 'supplierName',
        },
        {
          title: language['gift_merchant_name'],
          align: 'center',
          dataIndex: 'businessName',
        },
        {
          title: language['gift_user_app'],
          align: 'center',
          dataIndex: 'appName',
        },
        {
          title: language['gift_up_down'],
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'switchSlot' },
        },
        {
          title: language['common.action'],
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/gift/product/list',
        appListUrl: '/gift/app/list',
        venderListUrl: '/gift/vendor/list',
        delete: '/gift/product/delete',
        deleteBatch: '/gift/product/deleteBatch',
        exportXlsUrl: '/gift/product/export',
        turnStatus: '/gift/product/turnStatus',
        upOrDownBatch: '/gift/product/upOrDownBatch',
        queryById: '/gift/product/queryById',
        vendorListByApp: '/gift/vendor/listByApp',
        checkAppLimit: '/gift/app/checkAppLimit/code',
        importTemplate: '/gift/product/exportTemplate',
        importExcelUrl: 'gift/product/import',
        tagUrl: '/gift/product/tag/queryTagListByApp',
        businessBySupplier: '/gift/vendor/businessBySupplier'
      },
      dictOptions: {},
      superFieldList: [],
      currid: '',
      vendorList: [],
      appList: [],
      isHideDele: true,
      previewVisible: false,
      previewImage: '',
      applicationCode: 'gift',
      vendorMap: [],
      businessMap:[],
      appLimit: {
        flag: false,
        value: undefined
      },
      previewProduct: false,
      previewRecord: {},
      tags: [],
      images: [],
      previewProductList: false,
    }
  },
  created() {
    this.checkAppLimit();
    this.getAppListByStatus()
    this.getVendorListByStatus()
    if (this.$route.query.id !== undefined) {
      let param = {
        id: this.$route.query.id,
      }
      getAction(this.url.queryById, param).then((res) => {
        if (res.success) {
          this.handleDetail(res.result)
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    handleAdd: function () {
      this.$refs.modalForm.add(this.queryParam.app)
      this.$refs.modalForm.title = this.language['common.insertButton']
      this.$refs.modalForm.disableSubmit = false
    },
    handlePreviewProduct(record) {
      let result = []
      this.images = record.images && record.images.length > 0 ? record.images.split(',').map(key => this.getImgViewCode(key, 'gift')) : [];
      getAction(this.url.tagUrl, { app: record.app })
        .then((res) => {
          if (res.success) {
            let keyArr = Object.keys(res.result[0])
            const k = keyArr.map((item) => {
              result.push(...res.result[0][item]);
              return res.result[0][item]
            })
          } else {
            this.$message.warning(res.message)
          }
          this.tags = record.tag && record.tag.length > 0 ? record.tag.split(',').map(key => result.find(i => i.value == key).label) : [];
          this.previewRecord = record;
          this.previewProduct = true;
        })
    },
    closePreviewProduct() {
      this.previewProduct = false;
    },
    initActive(){

    },
    handlePreviewProductList() {
      this.previewProductList = true;

    },
    closePreviewProductList() {
      this.previewProductList = false;
    },
    downloadTemplate() {
      let fileName = "商品導入模板"
      downFile(this.url.importTemplate).then((data) => {
        if (!data) {
          this.$message.warning(this.language['common.fileDowloadError'])
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
        } else {
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      })
    },
    searchReset() {
      this.queryParam = {};
      if (this.appLimit.flag) {
        this.queryParam.app = this.appLimit.value;
        this.handlerApp(this.appLimit.value);
      } else {
        this.vendorMap = [];
      }
      this.supplierCode = undefined;
      this.loadData(1);
    },
    async checkAppLimit() {
      await getAction(this.url.checkAppLimit).then(res => {
        if (res.success) {
          this.appLimit.flag = true;
          this.appLimit.value = res.result;
          this.queryParam.app = res.result;
          this.handlerApp(res.result);
        }
      })
      this.loadData(1);
    },
    handlerApp(val) {
      this.getVendorList(val);
      this.queryParam.supplier = undefined;
    },
    updateSupplier(val) {
      this.queryParam.supplier = val;
      this.$forceUpdate();      
      // 获取商家名称列表
      this.getVendorbusinessList(val)
    },
    updateBusiness(val) {
      this.queryParam.businessName = val;
      this.$forceUpdate();
    },
    getVendorbusinessList(val){
      getAction(this.url.businessBySupplier,{supplier:val,appCode:this.queryParam.app}).then(res=>{
        if (res.success){
          const businessMap = {};
          if (res.result) {

            // 遍历原始对象的值
            Object.values(res.result).forEach(value => {
                businessMap[value] = value;
            });
          }
          this.businessMap = businessMap;
          console.log('商家列表', this.businessMap);
        }
      })
    },
    getVendorList(val) {
      getAction(this.url.vendorListByApp, { appCode: val }).then(res => {
        if (res.success) {
          const newVendorMap = {};
          if (res.result && Array.isArray(res.result)) {
            res.result.forEach(item => {
              // 將回傳的陣列轉換為 { code: name } 格式的物件
              newVendorMap[item.name] = item.name;
            });
          }
          this.vendorMap = newVendorMap;
        }
      })
    },
    getAppListByStatus() {
      var params = {
        status: 1,
        order: 'desc',
        pageNo: 1,
        pageSize: 99999,
      }
      getAction(this.url.appListUrl, params).then((res) => {
        if (res.success) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          const result = res.result.records || res.result
          this.appList = result.map((item, index, arr) => {
            let c = { label: item.name, value: item.code + '', active: item.active }
            return c
          })
        } else {
        }
      })
    },
    getVendorListByStatus() {
      var params = {
        status: 1,
        approveStatus: 1,
        order: 'desc',
        pageNo: 1,
        pageSize: 99999,
      }
      getAction(this.url.venderListUrl, params).then((res) => {
        if (res.success) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          const result = res.result.records || res.result
          this.vendorList = result.map((item, index, arr) => {
            let c = { label: item.name, value: item.code + '' }
            return c
          })
        } else {
        }
      })
    },
    handleCopy: function (record) {
      console.log('複製',record);
      
      this.$refs.modalForm.copy(record)
      this.$refs.modalForm.title = this.language['common.insertButton']
      this.$refs.modalForm.disableSubmit = false
    },

    changeStatus(checked, record, idx) {
      console.log('data', this.dataSource)
      console.log('checked', checked)
      postAction(this.url.turnStatus, record).then((res) => {
        if (res.success) {
          // this.loadData();
          if (this.dataSource[idx]) this.dataSource[idx].status = checked === 0 ? 1 : 0
          return true
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    handleUpOrDown(val) {
      let ids = this.selectedRowKeys.map((item) => item).join(',')
      getAction(this.url.upOrDownBatch, { status: val, ids: ids }).then((res) => {
        if (res.success) {
          this.loadData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleDelete: function (record) {
      var that = this
      deleteAction(that.url.delete, { id: record.id }).then((res) => {
        if (res.success) {
          //重新计算分页问题
          that.reCalculatePage(1)
          that.$message.success(res.message)
          that.loadData()
          this.onClearSelected()
        } else {
          that.$message.warning(res.message)
        }
      })
    },

    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
      this.selectionRows.forEach((item) => {
        this.isHideDele = item.status === 0 && item.activeStatus === 0
      })
    },

    imgView(text) {
      console.log('imgView text : ', text)
      this.previewImage = text
      this.previewVisible = true
    },
    // 关闭模态框
    handleCancel() {
      this.previewVisible = false
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
